export const SEARCH = {
    GLOBAL: "search",
    USERS: "users.search",
    PRODUCTS: "products.search",
    GROUPS: "groups.search",
    CLEAR: "search.clear",
};
